import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager, useLabel } from '@atlas/core';
import { BasePopup, Button, HeaderTitle, Icon } from '@atlas/ui';

const MessagesPopup = ({ data = {}, id }) => {
  const { onCancel, onConfirm } = data;

  const translatedTitle = useLabel('messages_pop_up_title');
  const translatedSubtitle = useLabel('messages_pop_up_message');

  const onCloseHandler = useCallback(() => {
    if (typeof onCancel === 'function') {
      onCancel();
    }

    NotificationManager.removeNotification(id);
  }, [id, onCancel]);

  const onConfirmHandler = useCallback(() => {
    if (typeof onConfirm === 'function') {
      onConfirm();
    }

    NotificationManager.removeNotification(id);
  }, [id, onConfirm]);

  return (
    <BasePopup className="messages-popup">
      <HeaderTitle className="messages-popup__header">
        <div className="header-title__children">
          <button onClick={onCloseHandler} type="button">
            <Icon name="close" />
          </button>
        </div>
      </HeaderTitle>

      <div className="messages-popup__content">
        <div className="icon-container">
          <Icon height={50} name="message" width={50} />
          <span className="red-dot" />
        </div>
        <p className="content-title">{translatedTitle}</p>
        <p className="content-subtitle">{translatedSubtitle}</p>
      </div>

      <div className="messages-popup__control">
        <Button className="secondary big block" label="cancel" onClick={onCloseHandler} />
        <Button
          className="primary big block"
          label="messages_pop_up_to_messages"
          onClick={onConfirmHandler}
        />
      </div>
    </BasePopup>
  );
};

MessagesPopup.propTypes = {
  data: PropTypes.shape({
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func,
  }),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default MessagesPopup;
